/* eslint-disable */
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import { Card, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useFormik, Form, FormikProvider } from 'formik';
import {
    Stack, TextField, CardContent, Button, Typography
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { ToastContainer, toast } from 'react-toastify';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Services';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecord: {
        backgroundColor: "green",
    },
    bold: {
        fontWeight: 600,
    }

}));


export default function OutletAddEdit(props) {
    const classes = useStyles();
    const screenCode = 'OUTLET';
    const navigate = useNavigate();
    const [isButtonEnable, setIsButtonEnable] = useState(false);
    const [factoryID, setFactoryID] = useState("");
    const [groupList, setGroupList] = useState([]);
    const [customerTypeList, setCustomerTypeList] = useState([]);
    const [grades, setGrades] = useState([]);
    const [factoryType, setFactoryType] = useState(0);
    const [canEdit, setCanEdit] = useState({
        editFactory: false
    });
    const [provinceList, setProvinceList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [gnDivisionList, setGnDivisionList] = useState([]);
    const [dsDivisionList, setDsDivisionList] = useState([]);

    const [formData, setFormData] = useState({
        groupID: "0",
        factoryCode: "",
        erimsOutletCode: "",
        gradeID: "0",
        customerTypeID: "0",
        factoryName: "",
        province: 0,
        district: 0,
        city: 0,
        gnDivisionID: 0,
        dsDivisionID: 0,
        address1: "",
        address2: "",
        mobileNumber: "",
        secondaryMobile: "",
        email: "",
        createdBy: "",
        isActive: true
    });


    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: false,
        submitButtonName: "Save",
        pageName: "Add Outlet"
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });
    const [checked, setChecked] = useState([]);
    const [LeftNewArray, setLeftNewArray] = useState([]);
    const [RightNewArray, setRightNewArray] = useState([]);
    const [RightNewArrayAlreadyStoredAccounts, setRightNewArrayAlreadyStoredAccounts] = useState([]);
    const [RemovedProductList, setRemovedProductList] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isGradeIDEnabled, setIsGradeIDEnabled] = useState(false);
    const [isFormReady, setIsFormReady] = useState(false);

    const leftChecked = intersection(checked, LeftNewArray);
    const rightChecked = intersection(checked, RightNewArray);

    const SearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required'),
        customerTypeID: Yup.number().min(1, 'Please select a Customer Type').required('Customer Type Required'),
        factoryCode: Yup.string().required('Outlet Code required').matches(/^\S+$/, 'Outlet Code cannot contain spaces'),
        erimsOutletCode: Yup.string().nullable().required('Location Code required').matches(/^\S+$/, 'Location Code cannot contain spaces'),
        factoryName: Yup.string().required('Outlet Name required').matches(/^[^\s]+(\s+[^\s]+)*$/, 'Outlet Name cannot start/end with spaces'),
        gradeID: Yup.number().min(1, 'Please select a Grade').required('Grade Required'),
        province: Yup.number().min(1, 'Please select a Province').required('Province Required'),
        district: Yup.number().min(1, 'Please select a District').required('District Required'),
        city: Yup.number().min(1, 'Please select a City').required('City Required'),
        dsDivisionID: Yup.number().min(1, 'Please select a DS Division').required('DS Division Required'),
        gnDivisionID: Yup.number().min(1, 'Please select a GN Division').required('GN Division Required'),
        address1: Yup.string().required('Address Line 1 Required').matches(/^[^\s]+(\s+[^\s]+)*$/, 'Address Line 1 cannot start/end with spaces'),
        address2: Yup.string().nullable().notRequired().matches(/^$|^[^\s]+(\s+[^\s]+)*$/, 'Address Line 2 cannot start/end with spaces'),
        mobileNumber: Yup.string()
            .required('Primary Contact Required')
            .matches(/^\d{10}$/, 'Primary Contact must be 10 digits')
            .test('not-all-zero', 'Primary Contact cannot be all zeros', function (value) {
                if (!value) return false;
                return !/^0{10}$/.test(value);
            }),
        email: Yup.string().email('Invalid email address').nullable().notRequired(),
    });

    function not(a, b) {
        return a.filter((value) => b.map(obj => obj.routeID).indexOf(value.routeID) === -1);
    }

    function intersection(a, b) {
        return a.filter((value) => b.map(obj => obj.routeID).indexOf(value.routeID) !== -1);
    }

    function getValueByKeys(obj, keys, defaultValue = '') {
        if (!obj || typeof obj !== 'object') {
            return defaultValue;
        }

        const sourceKeys = Object.keys(obj);

        for (const key of keys) {
            const directValue = obj?.[key];
            if (directValue !== undefined && directValue !== null && directValue !== '') {
                return directValue;
            }

            const matchedKey = sourceKeys.find((sourceKey) => sourceKey.toLowerCase() === key.toLowerCase());
            if (matchedKey) {
                const matchedValue = obj[matchedKey];
                if (matchedValue !== undefined && matchedValue !== null && matchedValue !== '') {
                    return matchedValue;
                }
            }
        }

        return defaultValue;
    }

    function getNumberByKeys(obj, keys, defaultValue = 0) {
        const value = getValueByKeys(obj, keys, defaultValue);
        const numberValue = parseInt(value, 10);
        return Number.isNaN(numberValue) ? defaultValue : numberValue;
    }

    function getBooleanByKeys(obj, keys, defaultValue = true) {
        const value = getValueByKeys(obj, keys, defaultValue);

        if (typeof value === 'boolean') {
            return value;
        }

        if (typeof value === 'string') {
            const normalized = value.toLowerCase().trim();
            if (normalized === 'true' || normalized === '1') {
                return true;
            }
            if (normalized === 'false' || normalized === '0') {
                return false;
            }
        }

        if (typeof value === 'number') {
            return value === 1;
        }

        return defaultValue;
    }

    const handleToggle = (value) => () => {
        const currentIndex = checked.map(obj => obj.routeID).indexOf(value.routeID);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    };

    const handleCheckedRight = () => {
        setRemovedProductList(RemovedProductList.concat(leftChecked));
        setRightNewArray(RightNewArray.concat(leftChecked));
        setLeftNewArray(not(LeftNewArray, leftChecked));
        setChecked(not(checked, leftChecked));
    };

    const handleCheckedLeft = () => {
        setRemovedProductList(RemovedProductList.concat(rightChecked));
        setLeftNewArray(LeftNewArray.concat(rightChecked));
        setRightNewArray(not(RightNewArray, rightChecked));
        setChecked(not(checked, rightChecked));
    };

    const handleScreenChange = (e, items) => {
        const newChecked = [...checked];
        if (e.target.checked) {
            const result = items.filter(x => !newChecked.some(y => y.routeID === x.routeID));
            setChecked([...newChecked, ...result]);
        } else {
            const result = newChecked.filter(x => !items.some(y => y.routeID === x.routeID));
            setChecked(result);
        }
    };

    const checkSelectLength = (checkedItems, items) => {
        return items.every(x => checkedItems.some(y => y.routeID === x.routeID));
    };

    const customList = (items) => (
        <Paper style={{ height: 400, overflow: 'auto' }}>
            <ListItem role="listitem">
                <ListItemIcon>
                    <Checkbox
                        disabled={items.length > 0 ? false : true}
                        color="secondary"
                        onClick={(e) => handleScreenChange(e, items)}
                        checked={items.length > 0 && checkSelectLength(checked, items)}
                    />
                </ListItemIcon>
                <ListItemText primary={"Select All"} />
            </ListItem>
            <List dense component="div" role="list">
                {items.map((value) => (
                    <ListItem key={value.routeID} role="listitem" button onClick={handleToggle(value)}>
                        <ListItemIcon>
                            <Checkbox
                                checked={checked.some(item => item.routeID === value.routeID)}
                                tabIndex={-1}
                                color="secondary"
                                disableRipple
                            />
                        </ListItemIcon>
                        <ListItemText primary={value.routeName} />
                    </ListItem>
                ))}
            </List>
        </Paper>
    );

    async function GetAllRoutesDetails() {
        const res = await services.GetAllRoutesDetails();
        if (res) {
            setRoutes(res);
            if (pageProps.isEdit) {
                trackPromise(fetchMappedRoutes());
            } else {
                setLeftNewArray(res);
            }
        }
    }



    const { operationEntityID } = useParams();
    let decrypted = 0;

    useEffect(() => {
        decrypted = AESDecryptionParam(operationEntityID);
        if (decrypted > 0) {
            setPageProps({
                ...pageProps,
                isEdit: true,
                submitButtonName: "Update",
                editingID: parseInt(decrypted),
                pageName: "Edit Outlet"
            })
            setCanEdit({
                ...canEdit,
                editFactory: true
            });
            setFactoryID(decrypted);

            trackPromise(SetDetailsForFactoryEdit(decrypted));
            trackPromise(fetchMappedRoutes(decrypted));
        } else {
            setIsFormReady(true);
            trackPromise((async () => {
                await Promise.all([GetAllRoutesDetails(), GetOutletCode()]);
            })());
        }
    }, []);



    useEffect(() => {
        getPermissions();
    }, [])


    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            factoryCode: formData.factoryCode,
            customerTypeID: formData.customerTypeID,
            erimsOutletCode: formData.erimsOutletCode,
            gradeID: formData.gradeID,
            factoryName: formData.factoryName,
            createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
            isActive: formData.isActive,
            province: formData.province,
            district: formData.district,
            city: formData.city,
            dsDivisionID: formData.dsDivisionID,
            gnDivisionID: formData.gnDivisionID,
            address1: formData.address1,
            address2: formData.address2,
            mobileNumber: formData.mobileNumber,
            secondaryMobile: formData.secondaryMobile,
            email: formData.email
        },
        validationSchema: SearchSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        }
    });

    const { errors, touched, setValues, handleSubmit, isSubmitting, getFieldProps, values } = formik;
    async function SetDetailsForFactoryEdit(factoryID) {

        if (canEdit != false) {
            let result = await services.GetFactoriesByFactoryIDFromOutletScreen(factoryID);
            const factory = Array.isArray(result) ? result[0] : result;
            let secondaryMobileValue = getValueByKeys(factory, ['secondaryMobile', 'SecondaryMobile'], '');
            if (secondaryMobileValue === 0 || secondaryMobileValue === '0') {
                secondaryMobileValue = '';
            }

            const savedGroupID = getNumberByKeys(factory, ['groupID', 'GroupID']);
            const savedCustomerTypeID = getNumberByKeys(factory, ['customerTypeID', 'CustomerTypeID']);
            const savedGradeID = getNumberByKeys(factory, ['gradeID', 'GradeID']);
            const savedProvince = getNumberByKeys(factory, ['province', 'Province']);
            const savedDistrict = getNumberByKeys(factory, ['district', 'District']);
            const savedCity = getNumberByKeys(factory, ['city', 'City']);
            const savedDsDivisionID = getNumberByKeys(factory, ['dsDivisionID', 'DSDivisionID']);
            const savedGnDivisionID = getNumberByKeys(factory, ['gnDivisionID', 'GnDivisionID']);

            const [groupData, customerTypeData, provinceData, gradeData] = await Promise.all([
                services.GetAllGroupsForOutletScreen(),
                services.GetAllCustomerTypes(),
                services.GetProvinceForDropdown(),
                services.GetGradeByGroupID(savedGroupID)
            ]);
            if (groupData) setGroupList(groupData);
            if (customerTypeData) setCustomerTypeList(customerTypeData);
            if (provinceData) setProvinceList(provinceData);
            if (gradeData) setGrades(gradeData);

            if (savedProvince > 0) {
                const districtData = await services.GetDistrictForDropdown(savedProvince);
                if (districtData) setDistrictList(districtData);
            }
            if (savedProvince > 0 && savedDistrict > 0) {
                const cityData = await services.GetCityForDropdown(savedProvince, savedDistrict);
                if (cityData) setCityList(cityData);
            }
            if (savedProvince > 0 && savedDistrict > 0 && savedCity > 0) {
                const dsDivisionData = await services.GetDsDivisionsForDropdown({
                    provinceID: savedProvince, districtID: savedDistrict, cityID: savedCity
                });
                if (dsDivisionData) setDsDivisionList(dsDivisionData);
            }
            if (savedProvince > 0 && savedDistrict > 0 && savedCity > 0 && savedDsDivisionID > 0) {
                const gnDivisionData = await services.GetGnDivisionsForDropdown({
                    provinceID: savedProvince, districtID: savedDistrict,
                    cityID: savedCity, dsDivisionID: savedDsDivisionID
                });
                if (gnDivisionData) setGnDivisionList(gnDivisionData);
            }

            setValues({
                createdBy: values.createdBy,
                factoryID: getNumberByKeys(factory, ['factoryID', 'FactoryID']),
                groupID: savedGroupID,
                factoryCode: getValueByKeys(factory, ['factoryCode', 'FactoryCode']),
                erimsOutletCode: getValueByKeys(factory, ['erimsOutletCode', 'ErimsOutletCode']),
                gradeID: savedGradeID,
                customerTypeID: savedCustomerTypeID,
                factoryName: getValueByKeys(factory, ['factoryName', 'FactoryName']),
                province: savedProvince,
                district: savedDistrict,
                city: savedCity,
                gnDivisionID: savedGnDivisionID,
                dsDivisionID: savedDsDivisionID,
                address1: getValueByKeys(factory, ['address1', 'Address1']),
                address2: getValueByKeys(factory, ['address2', 'Address2']),
                mobileNumber: (function () {
                    const mobile = String(getValueByKeys(factory, ['mobileNumber', 'MobileNumber'], '')).trim();
                    if (mobile === '' || mobile === '0') return '';
                    if (/^\d{9}$/.test(mobile)) return `0${mobile}`;
                    return mobile;
                })(),
                secondaryMobile: secondaryMobileValue,
                email: getValueByKeys(factory, ['email', 'Email']),
                isActive: getBooleanByKeys(factory, ['isActive', 'IsActive'], true),
            });
            setFactoryType(getNumberByKeys(factory, ['factoryType', 'FactoryType']));
            const orderConfig = await services.GetOrderConfigurationsByFactoryID(factoryID);
            if (orderConfig.length > 0) {
                setIsGradeIDEnabled(true);
            }

            setIsFormReady(true);
        }
    }
    async function fetchMappedRoutes() {
        const res = await services.GetMappedRoutesForOutlet(decrypted);
        const allRes = await services.GetAllRoutesDetails();
        if (res) {
            setRightNewArray(res);
            setRightNewArrayAlreadyStoredAccounts(res);
            setLeftNewArray(not(allRes, res));
        }
    }
    //tobackend
    async function SubmitForm() {

        if (canEdit.editFactory === false) {
            const requestModel = {
                ...formik.values,
                linkedProducts: not(RightNewArray, RightNewArrayAlreadyStoredAccounts),
                removedProducts: RemovedProductList,
                unmappedOutlets: not(routes, RightNewArray)
            };
            let res = await services.SaveFactoriesFromOutletScreen(requestModel);
            if (res.data > 0) {
                toast.success("New Outlet Added Succesfully");
                formik.resetForm();
                setTimeout(() => {
                    navigate('/dashboard/viewOutlet');
                }, 3000);
            } else if (res.data == -1) {
                toast.error("Outlet name Already exists");
            }
            else if (res.data == -2) {
                toast.error("Outlet code Already exists");
            }
            else if (res.data == -3) {
                toast.error(" Outlet code Already exists");
            }
            else {
                toast.error("Error!.New Outlet not created");
            }
        }
        else if (canEdit.editFactory != false) {
            let model = {
                ...formik.values,
                factoryID: parseInt(factoryID),
                createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                linkedProducts: (RightNewArray),
                removedProducts: RemovedProductList,
                unmappedOutlets: not(routes, RightNewArray),
                factoryType: factoryType
            }
            let res = await services.UpdateFactoryDetailsFromOutletScreen(model);
            if (res.statusCode === "Success") {
                toast.success(res.message);
                setTimeout(() => {
                    navigate('/dashboard/viewOutlet');
                    SetDetailsForFactoryEdit(factoryID);
                }, 3000);
            } else if (res.data == -1) {
                toast.error("Outlet name Already exists");
            }
            else if (res.data == -2) {
                toast.error("Outlet code Already exists");
            }
            else if (res.data == -3) {
                toast.error("Location code Already exists");
            }
            else {
                toast.error("Error!.Update Outlet");
            }
        }
        else {
            toast.error(res.message);
        }
    }

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'OUTLET');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        });
    }

    useEffect(() => {
        GetAllGroups();
    }, []);

    useEffect(() => {
        GetAllCustomerTypes();
    }, []);

    useEffect(() => {
        GetGradeByGroupID();
    }, [values.groupID]);

    useEffect(() => {
        getProvinceForDropdown();
    }, []);

    useEffect(() => {
        (getDistrictForDropdown());
    }, [formik.values.province]);

    useEffect(() => {
        (getCityForDropdown());
    }, [formik.values.province, formik.values.district]);

    useEffect(() => {
        (getDsDivisionsForDropdown());
    }, [formik.values.province, formik.values.district, formik.values.city]);

    useEffect(() => {
        (getGnDivisionsForDropdown());
    }, [formik.values.province, formik.values.district, formik.values.city, formik.values.dsDivisionID]);

    async function GetAllGroups() {
        var res = await services.GetAllGroupsForOutletScreen();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetGradeByGroupID() {
        var res = await services.GetGradeByGroupID(values.groupID);
        if (res != null) {
            setGrades(res);
        }
    }

    async function GetAllCustomerTypes() {
        var res = await services.GetAllCustomerTypes();
        if (res != null) {
            setCustomerTypeList(res);
        }
    }


    async function GetOutletCode() {
        var res = await services.GetOutletCode();
        if (res != null) {
            const nextCode = res?.data?.[0]?.nextOutletCode ?? res?.nextOutletCode ?? res;
            formik.setFieldValue('factoryCode', nextCode ?? '');
        }
    }

    function generateProvinceDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(<MenuItem key={x.provinceID} value={x.provinceID}>{x.provinceName}</MenuItem>)
            });
        }
        return items
    }

    function generateDistrictDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(<MenuItem key={x.districtID} value={x.districtID}>{x.districtName}</MenuItem>)
            });
        }
        return items
    }

    function generateCityDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(<MenuItem key={x.cityID} value={x.cityID}>{x.cityName}</MenuItem>)
            });
        }
        return items
    }

    function generateDsDivisionDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(<MenuItem key={x.dsDivisionID} value={x.dsDivisionID}>{x.dsDivisionName}</MenuItem>)
            });
        }
        return items
    }

    function generateGnDivisionDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(<MenuItem key={x.gnDivisionID} value={x.gnDivisionID}>{x.gnDivisionName}</MenuItem>)
            });
        }
        return items
    }

    async function getProvinceForDropdown() {
        const province = await services.GetProvinceForDropdown();
        setProvinceList(province);
    }

    async function getDistrictForDropdown() {
        const district = await services.GetDistrictForDropdown(formik.values.province);
        setDistrictList(district);
    }

    async function getCityForDropdown() {
        const city = await services.GetCityForDropdown(formik.values.province, formik.values.district);
        setCityList(city);
    }

    async function getDsDivisionsForDropdown() {
        if (formik.values.province != 0 && formik.values.district != 0 && formik.values.city != 0) {
            let model = {
                provinceID: parseInt(formik.values.province),
                districtID: parseInt(formik.values.district),
                cityID: parseInt(formik.values.city)
            }
            const dsDivision = await services.GetDsDivisionsForDropdown(model);
            setDsDivisionList(dsDivision);
        }
    }

    async function getGnDivisionsForDropdown() {
        if (formik.values.province != 0 && formik.values.district != 0 && formik.values.city != 0 && formik.values.dsDivisionID != 0) {
            let model = {
                provinceID: parseInt(formik.values.province),
                districtID: parseInt(formik.values.district),
                cityID: parseInt(formik.values.city),
                dsDivisionID: parseInt(formik.values.dsDivisionID)
            }
            const gnDivision = await services.GetGnDivisionsForDropdown(model);
            setGnDivisionList(gnDivision);
        }
    }



    function clearAll() {
        setValues({
            ...values,
            factoryCode: "",
            factoryName: "",
            erimsOutletCode: "",
            gradeID: 0
            //isActive: false
        })
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Add Outlet |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/viewOutlet"}
                        btname="Back"
                        pageName={pageProps.pageName}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        {isFormReady && (
                            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                                <Stack spacing={4}>
                                    <Stack spacing={2}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Group *"
                                                value={formik.values.groupID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('groupID')}
                                                error={Boolean(touched.groupID && errors.groupID)}
                                                helperText={touched.groupID && errors.groupID}
                                                InputProps={{
                                                    readOnly: !permissionList.isGroupFilterEnabled
                                                }}
                                            >
                                                <MenuItem key={0} value={0}>Select Group</MenuItem>
                                                {groupList.map((option) => (
                                                    <MenuItem key={option.groupID} value={option.groupID}>
                                                        {option.groupName}
                                                    </MenuItem>
                                                ))}
                                            </TextField>

                                            {pageProps.isEdit && (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Outlet Code *"
                                                    value={formik.values.factoryCode}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('factoryCode')}
                                                    disabled={pageProps.isEdit}
                                                    InputProps={{
                                                        readOnly: pageProps.isEdit
                                                    }}
                                                    error={Boolean(touched.factoryCode && errors.factoryCode)}
                                                    helperText={touched.factoryCode && errors.factoryCode}
                                                />
                                            )}

                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Location Code *"
                                                value={formik.values.erimsOutletCode}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('erimsOutletCode')}
                                                error={Boolean(touched.erimsOutletCode && errors.erimsOutletCode)}
                                                helperText={touched.erimsOutletCode && errors.erimsOutletCode}
                                            />
                                        </Stack>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Grade *"
                                                value={formik.values.gradeID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('gradeID')}
                                                error={Boolean(touched.gradeID && errors.gradeID)}
                                                helperText={touched.gradeID && errors.gradeID}
                                            >
                                                <MenuItem key={0} value={0}>Select Grade</MenuItem>
                                                {grades.map((option) => (
                                                    <MenuItem key={option.gradeID} value={option.gradeID}>
                                                        {option.gradeName}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Outlet Name *"
                                                value={formik.values.factoryName}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('factoryName')}
                                                error={Boolean(touched.factoryName && errors.factoryName)}
                                                helperText={touched.factoryName && errors.factoryName}
                                            />

                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Customer Type *"
                                                value={formik.values.customerTypeID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('customerTypeID')}
                                                //disabled={pageProps.isEdit}
                                                error={Boolean(touched.customerTypeID && errors.customerTypeID)}
                                                helperText={touched.customerTypeID && errors.customerTypeID}
                                            >
                                                <MenuItem key={0} value={0}>Select customer Type</MenuItem>
                                                {customerTypeList.map((option) => (
                                                    <MenuItem key={option.customerTypeID} value={option.customerTypeID}>
                                                        {option.customerTypeName}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Stack>
                                        <Divider variant="middle" />
                                        <Typography variant="h8">
                                            <b>{"Address"}</b>
                                        </Typography>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Province *"
                                                name="province"
                                                value={formik.values.province}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('province')}
                                                error={Boolean(touched.province && errors.province)}
                                                helperText={touched.province && errors.province}
                                            >
                                                <MenuItem key={0} value={0}> Select Province</MenuItem>
                                                {generateProvinceDropDownMenu(provinceList)}
                                            </TextField>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="District *"
                                                name="district"
                                                value={formik.values.district}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('district')}
                                                error={Boolean(touched.district && errors.district)}
                                                helperText={touched.district && errors.district}
                                            >
                                                <MenuItem key={0} value={0}> Select District</MenuItem>
                                                {generateDistrictDropDownMenu(districtList)}
                                            </TextField>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="City *"
                                                name="city"
                                                value={formik.values.city}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('city')}
                                                error={Boolean(touched.city && errors.city)}
                                                helperText={touched.city && errors.city}
                                            >
                                                <MenuItem key={0} value={0} > Select City</MenuItem>
                                                {generateCityDropDownMenu(cityList)}

                                            </TextField>

                                        </Stack>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="DS Division *"
                                                name="dsDivisionID"
                                                value={formik.values.dsDivisionID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('dsDivisionID')}
                                                error={Boolean(touched.dsDivisionID && errors.dsDivisionID)}
                                                helperText={touched.dsDivisionID && errors.dsDivisionID}
                                            >
                                                <MenuItem key={0} value={0} > Select DS Division</MenuItem>
                                                {generateDsDivisionDropDownMenu(dsDivisionList)}

                                            </TextField>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="GN Division *"
                                                name="gnDivisionID"
                                                value={formik.values.gnDivisionID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('gnDivisionID')}
                                                error={Boolean(touched.gnDivisionID && errors.gnDivisionID)}
                                                helperText={touched.gnDivisionID && errors.gnDivisionID}
                                            >
                                                <MenuItem key={0} value={0} > Select GN Division</MenuItem>
                                                {generateGnDivisionDropDownMenu(gnDivisionList)}

                                            </TextField>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Address Line 1 *"
                                                value={formik.values.address1}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('address1')}
                                                error={Boolean(touched.address1 && errors.address1)}
                                                helperText={touched.address1 && errors.address1}
                                            />

                                        </Stack>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Address Line 2"
                                                value={formik.values.address2}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('address2')}
                                                error={Boolean(touched.address2 && errors.address2)}
                                                helperText={touched.address2 && errors.address2}
                                            />
                                            <TextField fullWidth size="small" style={{ visibility: 'hidden' }} disabled />
                                            <TextField fullWidth size="small" style={{ visibility: 'hidden' }} disabled />
                                        </Stack>

                                        <Divider variant="middle" />
                                        <Typography variant="h8">
                                            <b>{"Contact Number/s"}</b>
                                        </Typography>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Primary Contact *"
                                                value={formik.values.mobileNumber}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('mobileNumber')}
                                                error={Boolean(touched.mobileNumber && errors.mobileNumber)}
                                                helperText={touched.mobileNumber && errors.mobileNumber}
                                            />
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Secondary Contact "
                                                value={formik.values.secondaryMobile}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('secondaryMobile')}
                                                error={Boolean(touched.secondaryMobile && errors.secondaryMobile)}
                                                helperText={touched.secondaryMobile && errors.secondaryMobile}
                                            />
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Email Address"
                                                value={formik.values.email}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('email')}
                                                error={Boolean(touched.email && errors.email)}
                                                helperText={touched.email && errors.email}
                                            />
                                        </Stack>

                                    </Stack>

                                    <Box mt={4}>
                                        <Card>
                                            <CardContent>
                                                <Typography variant="h6" gutterBottom>Route Mapping</Typography>
                                                <Grid container spacing={3} alignItems="center">
                                                    <Grid item xs={5}>
                                                        <Typography variant="subtitle1">Available Routes</Typography>
                                                        {customList(LeftNewArray)}
                                                    </Grid>

                                                    <Grid item xs={2}>
                                                        <Grid container direction="column" alignItems="center">
                                                            <Button
                                                                variant="outlined"
                                                                size="small"
                                                                onClick={handleCheckedRight}
                                                                disabled={!LeftNewArray.length}
                                                                style={{ marginBottom: 8 }}
                                                            >
                                                                &gt;
                                                            </Button>
                                                            <Button
                                                                variant="outlined"
                                                                size="small"
                                                                onClick={handleCheckedLeft}
                                                                disabled={!RightNewArray.length}
                                                            >
                                                                &lt;
                                                            </Button>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={5}>
                                                        <Typography variant="subtitle1">Mapped Routes</Typography>
                                                        {customList(RightNewArray)}
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Box>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    value={formik.values.isActive}
                                                    checked={formik.values.isActive}
                                                    {...getFieldProps('isActive')}
                                                    onClick={formik.handleChange}
                                                    color='error'
                                                    name="isActive"
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                />}
                                            label="Is Active"
                                        />
                                    </Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            disabled={pageProps.isEdit}
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                        <Button
                                            disabled={isButtonEnable}
                                            type="submit"
                                            variant="contained"
                                            color='secondary'
                                        >{pageProps.submitButtonName}</Button>
                                    </Stack>
                                </Stack>
                            </Form>
                        )}
                    </FormikProvider>
                </Container>
            </Page>
        </>
    );
}

